<template>
  <div class="nav-bar">
    <div class="left">
      <a class="logo" href="http://www.hxmt.cn">HXMT</a>
      <div class="nav-menu">
        <div 
          class="menu-item"
          :class="{'menu-active': activeMenu === 'proposal'}"
          @click="changPage('proposal')">
          {{$t('navBar.proposal')}}
        </div>
        <div
          class="menu-item"
          :class="{'menu-active': activeMenu === 'grb'}"
          @click="changPage('grb')">
          GRB
        </div>
        <div
          v-if="showsem"
          class="menu-item"
          :class="{'menu-active': activeMenu === 'sem'}"
          @click="changPage('sem')">
          SEM
        </div>
      </div>
    </div>
    <div class="right">
      <el-dropdown trigger="click" @command="changLanguage">
        <div class="select-language">
          <span>{{$t('navBar.language')}}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu class="top-bar-dropdown" slot="dropdown">
          <el-dropdown-item :disabled="language==='zh'" command="zh">
            中文
          </el-dropdown-item>
          <el-dropdown-item :disabled="language==='en'" command="en">
            English
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown trigger="click" v-if="userInfo" @command="handleCommand">
        <div class="user-wrapper">
          <span class="user-name">{{userInfo.truename}}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>
        <el-dropdown-menu class="top-bar-dropdown" slot="dropdown">
          <el-dropdown-item v-if="userInfo.isadmin>0" class="logout-link" command="/admin/index">
            {{$t('navBar.SystemAdmin')}}
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/UserCenter/usrceninfo">
            {{$t('navBar.UserCenter')}}
          </el-dropdown-item>
          <el-dropdown-item class="logout-link" command="/iapi/logout">
            {{$t('navBar.logout')}}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <a class="login-link" v-else href="/iapi/login">{{$t('navBar.login')}}</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';

export default {
  props: {
    activeMenu: {
      type: String,
      default: 'proposal',
    },
  },
  data(){
    return{
      showsem: false
    };

  },
  computed: {
    ...mapState([
      'userInfo',
      'language',
    ]),
  },
  created() {
    this.getData();
  },
  methods: {
    getData(){
      const params = {
        parname:'SEM页面开关',
      }
      axios.post('/iapi/getparame', params).then((res) => {
        if (res.data.errcode === 0) {
          if(res.data.data==='open'){
            this.showsem = true;
          }
        }
      });

    },
    changPage(name) {
      if (this.activeMenu !== name) {
        this.$router.push({name});
      }
    },
    changLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('setLanguage', lang);
    },
    handleCommand(param) {
      location.href = param;
    },
  },
};
</script>

<style scoped lang="scss">
.nav-bar {
  background-color: #0058a3;
  box-shadow: 0px 3px 16px rgba(0,0,0,0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 56px;
}
.left, .right {
  display: flex;
  align-items: center;
}
.right {
  justify-content: right;
}
.logo {
  margin-right: 56px;
  font-size: 26px;
  display: block;
  color: #fff;
  font-weight: 500;
}
.logo-img {
  margin-right: 56px;
}
.nav-menu {
  display: flex;
  height: 56px;
}
.menu-item {
  height: 56px;
  line-height: 56px;
  margin-right: 16px;
  border-bottom: 2px solid transparent;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  &:hover {
    border-color: #fff;
  }
}
.menu-item.menu-active {
  border-color: #fff;
}
.select-language {
  font-size: 13px;
  color: #fff;
  height: 56px;
  line-height: 56px;
  cursor: pointer;
  margin-right: 18px;
}
.user-wrapper {
  font-size: 13px;
  color: #fff;
  height: 56px;
  line-height: 56px;
  cursor: pointer;
}
.login-link {
  color: #fff;
}
.logout-link {
  display: block;
  color: #606266;
  &:hover {
    color: #0058a3;
  }
}
</style>

<style lang="scss">
.el-dropdown-menu.top-bar-dropdown {
  padding: 6px 0;
  margin: 6px;
}
</style>
